const actions = {
  CREATE_RECEIPT_TOOL: 'CREATE_RECEIPT_TOOL',
  CREATE_RECEIPT_TOOL_ENDED: 'CREATE_RECEIPT_TOOL_ENDED',
  SEARCH_RECEIPT_TOOLS: 'SEARCH_RECEIPT_TOOLS',
  SEARCH_RECEIPT_TOOLS_ENDED: 'SEARCH_RECEIPT_TOOLS_ENDED',
  SEARCH_RECEIPTS: 'SEARCH_RECEIPTS',
  SEARCH_RECEIPTS_ENDED: 'SEARCH_RECEIPTS_ENDED',
  SEARCH_RECEIPT_ISSUED_RECORDS: 'SEARCH_RECEIPT_ISSUED_RECORDS',
  SEARCH_RECEIPT_ISSUED_RECORDS_ENDED: 'SEARCH_RECEIPT_ISSUED_RECORDS_ENDED',
  SEARCH_CREDITS: 'SEARCH_CREDITS',
  SEARCH_CREDITS_ENDED: 'SEARCH_CREDITS_ENDED',
  SEARCH_CREDIT_ALLOWANCE_RECORDS: 'SEARCH_CREDIT_ALLOWANCE_RECORDS',
  SEARCH_CREDIT_ALLOWANCE_RECORDS_ENDED: 'SEARCH_CREDIT_ALLOWANCE_RECORDS_ENDED',
  UPDATE_RECEIPT_TOOL: 'UPDATE_RECEIPT_TOOL',
  UPDATE_RECEIPT_TOOL_ENDED: 'UPDATE_RECEIPT_TOOL_ENDED',
  UPDATE_RECEIPT_IF_INIT: 'UPDATE_RECEIPT_IF_INIT',
  UPDATE_RECEIPT_IF_INIT_ENDED: 'UPDATE_RECEIPT_IF_INIT_ENDED',
  UPDATE_RECEIPT_IF_INVALIDATION_INIT: 'UPDATE_RECEIPT_IF_INVALIDATION_INIT',
  UPDATE_RECEIPT_IF_INVALIDATION_INIT_ENDED: 'UPDATE_RECEIPT_IF_INVALIDATION_INIT_ENDED',
  UPDATE_CREDIT_IF_INVALIDATION_INIT: 'UPDATE_CREDIT_IF_INVALIDATION_INIT',
  UPDATE_CREDIT_IF_INVALIDATION_INIT_ENDED: 'UPDATE_CREDIT_IF_INVALIDATION_INIT_ENDED',
  ISSUE_RECEIPT_IF_UNPROCESSED_OR_FAILED: 'ISSUE_RECEIPT_IF_UNPROCESSED_OR_FAILED',
  ISSUE_RECEIPT_IF_UNPROCESSED_OR_FAILED_ENDED: 'ISSUE_RECEIPT_IF_UNPROCESSED_OR_FAILED_ENDED',
};

export default actions;
